/** What the thread should do with its scroll position after the message list changed. */
export type ThreadScrollAction =
  /** Jump to the newest message. */
  | 'bottom'
  /** Older messages arrived: bring the Load-older control back into view. */
  | 'load-more'
  /** Older messages arrived with nothing left to load: hold the reading position. */
  | 'preserve'
  | 'none'

export interface ThreadScrollInput {
  messageCount: number
  previousCount: number
  /** The list's first id changed — older messages were prepended. */
  firstIdChanged: boolean
  isInitialLoad: boolean
  wasAtBottom: boolean
  /** A Load-older control is still rendered above the list. */
  hasMore: boolean
}

/**
 * Older messages are prepended and new replies appended, so list growth alone cannot tell
 * them apart — following it blindly threw the operator to the newest message whenever they
 * loaded history while still near the bottom.
 */
export function resolveThreadScrollAction({
  messageCount,
  previousCount,
  firstIdChanged,
  isInitialLoad,
  wasAtBottom,
  hasMore,
}: ThreadScrollInput): ThreadScrollAction {
  const grew = messageCount > previousCount
  if (grew && previousCount > 0 && firstIdChanged) return hasMore ? 'load-more' : 'preserve'
  if (isInitialLoad && messageCount > 0) return 'bottom'
  if (grew && (previousCount === 0 || wasAtBottom)) return 'bottom'
  return 'none'
}
